<template>
  <v-card>
    <v-card-title>
      {{ title }}
      <v-btn v-if="!hideCreate" @click="loadItems()" icon>
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn @click="$emit('click:add')" color="primary">
        <v-icon left>mdi-plus</v-icon>
        Adicionar
      </v-btn>
    </v-card-title>

    <v-card-subtitle>
      <v-text-field
        v-if="!hideSearch"
        v-model="filter"
        @keydown.enter="loadItems()"
        style="max-width: 300px;"
        prepend-inner-icon="mdi-magnify"
        label="Pesquisar"
        hide-details
        single-line
        outlined
        dense
      ></v-text-field>
    </v-card-subtitle>

    <v-data-table :headers="headers" :loading="loading" :items="items">
      <template
        v-for="(_, name) in $scopedSlots"
        :slot="name"
        slot-scope="slotData"
        ><slot :name="name" v-bind="slotData"
      /></template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  props: {
    title: String,
    headers: Array,
    indexer: Function,
    hideCreate: Boolean,
    hideSearch: Boolean
  },

  data() {
    return {
      items: [],
      loading: false,
      filter: ""
    };
  },

  methods: {
    async loadItems() {
      this.loading = true;

      try {
        this.items = await this.indexer(this.filter);
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    }
  },

  created() {
    this.loadItems();
  }
};
</script>
